<button
  mat-stroked-button
  class="update-button"
  [class.update-button--toggled]="value()"
  [disabled]="disabled()"
  (click)="emitToggled()"
>
  <mat-icon class="update-button__icon material-icons-outlined">update</mat-icon>
</button>
